document.addEventListener("DOMContentLoaded", function () {
  window.dispatchEvent(new Event('resize'));
  const header = document.getElementById("section-header");
  window.addEventListener("scroll", function () {
    if (window.scrollY >= 100) {
      header.classList.add("fixed");
    } else {
      header.classList.remove("fixed");
    }
  });
});

// ------------------------------ //
// OPTIMIZED PREMIUM ANIMATIONS   //
// ----------------------------- //
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) return;
    const mobileDuration  = 450;   
    const desktopDuration = 700;  
    const dur   = isMobile ? mobileDuration  : desktopDuration;
    const dist  = isMobile ? "24px"          : "36px"; 
    const sr = ScrollReveal({
        reset: false,
        useDelay: "onload",
        viewFactor: 0.05, 
        viewOffset: { top: 0, right: 0, bottom: 0, left: 0 }
    });
    sr.reveal(
        [
            ".reveal",
            ".shopify-policy__body h1",
            ".shopify-policy__body h2",
            ".shopify-policy__body h3",
            ".shopify-policy__body p",
            ".shopify-policy__body ul li"
        ].join(", "),
        {
            delay: isMobile ? 0 : 80,      
            distance: dist,
            origin: "bottom",
            duration: dur,
            easing: "cubic-bezier(0.22, 1, 0.36, 1)",  
            interval: isMobile ? 40 : 70  
        }
    );
    sr.reveal(
        ".reveal-bottom-item , .tr-swiper-outer , .purys-filter-topbar , body .product.product--medium .grid__item.product__media-wrapper , .related-products ,body .product.product--medium .product__info-wrapper , .ec-heading__eyebrow , .ec-heading__title  , .ec-swiper-outer , .bottom_note , .flex-top-bar .btn ",
        {
            delay: isMobile ? 0 : 60,      
            distance: dist,
            origin: "bottom",
            duration: dur,
            easing: "cubic-bezier(0.22, 1, 0.36, 1)",
            interval: isMobile ? 60 : 100 
        }
    );

    sr.reveal(
        ".fade-in-scroll",
        {
            delay: 0,                       
            duration: isMobile ? 350 : 420,
            distance: "0px",
            opacity: 0,
            scale: isMobile ? 0.99 : 0.97,
            easing: "cubic-bezier(0.22, 1, 0.36, 1)",
            interval: isMobile ? 35 : 55   
        }
    );

    sr.reveal(
        ".reveal-bottom",
        {
            origin: "bottom",
            distance: dist,
            duration: dur,
            delay: 0,
            easing: "cubic-bezier(0.22, 1, 0.36, 1)"
        }
    );

});

document.addEventListener("DOMContentLoaded", function () {
  function initRelatedProductsSlider() {
    const grid = document.querySelector('.related-products .grid.product-grid');
    if (!grid || grid.classList.contains('swiper-ready')) return;

    grid.classList.add('swiper-ready');

    const items = grid.querySelectorAll('.grid__item');
    if (!items.length) return;

    const swiperWrapper = document.createElement('div');
    swiperWrapper.className = 'swiper-wrapper';

    items.forEach(item => {
      item.classList.add('swiper-slide');
      swiperWrapper.appendChild(item);
    });

    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'swiper related-products-swiper';
    swiperContainer.appendChild(swiperWrapper);

    grid.parentNode.replaceChild(swiperContainer, grid);

    swiperContainer.insertAdjacentHTML(
      'afterend',
      `
      <div class="related-products-navigation">
        <div class="swiper-button-prev related-prev"></div>
        <div class="swiper-button-next related-next"></div>
      </div>
      <div class="swiper-pagination related-pagination"></div>
      `
    );

    new Swiper('.related-products-swiper', {
      slidesPerView: 5,
      spaceBetween: 20,
      loop: true,

      autoplay: {
        delay: 7000,
        disableOnInteraction: false
      },

      navigation: {
        nextEl: '.related-next',
        prevEl: '.related-prev',
      },

      pagination: {
        el: '.related-pagination',
        clickable: true,
      },

      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 5,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 10,
        }
      }
    });
  }

  initRelatedProductsSlider();

  const observer = new MutationObserver(() => {
    initRelatedProductsSlider();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


document.addEventListener('toggle', function (event) {
  const details = event.target;
  if (!details || !details.matches('details.mobile-facets__disclosure')) return;

  const filter = document.querySelector('#main-collection-filters') || document.querySelector('#main-search-filters');
  if (!filter) return;

  if (details.open) {
    filter.classList.add('open');
  } else {
    filter.classList.remove('open');
  }
}, true);



// ----add to cart button add sticky------//

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('#ProductSubmitButton-template--26669802488088__main');
  if (!btn) return;

  const wrap = document.createElement('div');
  wrap.className = 'sticky-atc-mobile';
  const clone = btn.cloneNode(true);
  clone.removeAttribute('id');
  wrap.appendChild(clone);
  document.body.appendChild(wrap);

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  new IntersectionObserver(([entry]) => {
    const show = isMobile() && !entry.isIntersecting && entry.boundingClientRect.top < 0;
    wrap.classList.toggle('is-visible', show);
  }).observe(btn);

  window.addEventListener('resize', () => {
    if (!isMobile()) wrap.classList.remove('is-visible');
  });

  const sync = () => {
    clone.className = btn.className;
    clone.disabled = btn.disabled;
    [...btn.attributes].forEach(a => a.name !== 'id' && clone.setAttribute(a.name, a.value));
    clone.innerHTML = btn.innerHTML;
  };
  new MutationObserver(sync).observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
  sync();

  clone.addEventListener('click', e => {
    e.preventDefault();
    btn.click();
  });
});
